export const MAP_TEST_ID = 'map';
